(() => {
  const initBackToTop = () => {
    if (document.querySelector('.ta-back-to-top')) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ta-back-to-top';
    button.setAttribute('aria-label', 'Volver arriba');
    button.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="M12 19V5M6.5 10.5 12 5l5.5 5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    document.body.appendChild(button);

    const update = () => button.classList.toggle('is-visible', window.scrollY > 700);
    window.addEventListener('scroll', update, { passive: true });
    button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    update();
  };

  const initHeaderState = () => {
    const header = document.querySelector('.section-header');
    if (!header) return;
    const update = () => header.classList.toggle('ta-header-scrolled', window.scrollY > 20);
    window.addEventListener('scroll', update, { passive: true });
    update();
  };

  const init = () => {
    initBackToTop();
    initHeaderState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
